export const response_7 = [
  {
    id: 64,
    date: '2022-08-02T15:52:00',
    date_gmt: '2022-08-02T12:52:00',
    guid: {
      rendered: 'https://spasmalgon.ru/?post_type=instrucrions&#038;p=64',
    },
    modified: '2024-02-13T18:03:08',
    modified_gmt: '2024-02-13T15:03:08',
    slug: '%d1%81%d0%bf%d0%b0%d0%b7%d0%bc%d0%b0%d0%bb%d0%b3%d0%be%d0%bd',
    status: 'publish',
    type: 'instrucrions',
    link: 'https://spasmalgon.teva.ru/instrucrions/%d1%81%d0%bf%d0%b0%d0%b7%d0%bc%d0%b0%d0%bb%d0%b3%d0%be%d0%bd/',
    title: {
      rendered: 'СПАЗМАЛГОН',
    },
    content: {
      rendered: '',
      protected: false,
    },
    featured_media: 0,
    template: '',
    acf: {
      text: '<p><strong>Спазмалгон® принимается при болевом синдроме умеренной или слабой выраженности:</strong></p>\n<ul>\n<li>головная;</li>\n<li>зубная боль;</li>\n<li>мигрень (приступообразная головная боль);</li>\n<li>невралгия, (боль по ходу нерва или его ветвей);</li>\n<li>миалгия (боли в мышцах);</li>\n<li>артралгия (боли в суставах);</li>\n<li>альгодисменорея (менструальные боли);</li>\n<li>боль при травмах и ожогах.</li>\n</ul>\n<p>Препарат предназначен для уменьшения симптомов на момент приема и на прогрессирование заболевания не влияет.</p>\n<p><strong class="small-mb">Способ применения и дозы Спазмалгон®</strong></p>\n<p class="small-mb">Внутрь: лучше после еды, не разжевывая, запивая водой.</p>\n<p class="small-mb">Рекомендуемые суточные дозы:</p>\n<p class="small-mb">Взрослые и дети от 15 лет: 1-2 таблетки 2-3 раза в сутки. Суточная доза не должна превышать 6 таблеток.</p>\n<p class="small-mb">У детей препарат применяют только по назначению врача. Дети от 8 до 11 лет – по половине таблетки 2-3 раза в сутки. Дети от 12 до 15 лет – по одной таблетке 2-3 раза в сутки.</p>\n',
      file: 'https://spasmalgon.teva.ru/spas.pill.03.04.2023_0003.pdf',
      sup: 'Скачать листок-вкладыш – информация для пациента Спазмалгон® ЛП-№(002098)-(РГ-RU)'
    },
    _links: {
      self: [
        {
          href: 'https://spasmalgon.teva.ru/wp-json/wp/v2/instrucrions/64',
        },
      ],
      collection: [
        {
          href: 'https://spasmalgon.teva.ru/wp-json/wp/v2/instrucrions',
        },
      ],
      about: [
        {
          href: 'https://spasmalgon.teva.ru/wp-json/wp/v2/types/instrucrions',
        },
      ],
      'wp:attachment': [
        {
          href: 'https://spasmalgon.teva.ru/wp-json/wp/v2/media?parent=64',
        },
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true,
        },
      ],
    },
  },
  {
    id: 65,
    date: '2020-01-21T12:14:37',
    date_gmt: '2020-01-21T09:14:37',
    guid: {
      rendered: 'https://spasmalgon.ru/?post_type=instrucrions&#038;p=65',
    },
    modified: '2024-02-13T18:03:50',
    modified_gmt: '2024-02-13T15:03:50',
    slug: '%d1%81%d0%bf%d0%b0%d0%b7%d0%bc%d0%b0%d0%bb%d0%b3%d0%be%d0%bd-%d1%8d%d1%84%d1%84%d0%b5%d0%ba%d1%82',
    status: 'publish',
    type: 'instrucrions',
    link: 'https://spasmalgon.teva.ru/instrucrions/%d1%81%d0%bf%d0%b0%d0%b7%d0%bc%d0%b0%d0%bb%d0%b3%d0%be%d0%bd-%d1%8d%d1%84%d1%84%d0%b5%d0%ba%d1%82/',
    title: {
      rendered: 'СПАЗМАЛГОН ЭФФЕКТ',
    },
    content: {
      rendered: '',
      protected: false,
    },
    featured_media: 0,
    template: '',
    acf: {
      text: '<p><strong>Показания к применению СПАЗМАЛГОН® ЭФФЕКТ</strong></p>\n<ul>\n<li>болевой синдром различного генеза, включая боли в суставах, мышцах; при радикулите, альгодисменорее (менструальных болях), невралгии, зубной боли, головной боли (в том числе при головной боли, обусловленной спазмом сосудов головного мозга);</li>\n<li>болевой синдром, связанный со спазмом гладкой мускулатуры, в том числе при хроническом холецистите, желчекаменной болезни, постхолецистэктомическом синдроме, почечной колике;</li>\n<li>посттравматический и послеоперационный болевой синдром, в том числе сопровождающийся воспалением;</li>\n<li>простудные заболевания, сопровождающиеся лихорадочным синдромом (в качестве симптоматической терапии).</li>\n</ul>\n<p><strong class="small-mb">Способ применения и дозы СПАЗМАЛГОН® ЭФФЕКТ</strong></p>\n<p class="small-mb">Таблетки принимайте внутрь лучше после еды, не разжевывая, запивая водой.<br />\nРекомендуемая суточная доза для взрослых – по 1 таблетке 1-3 раза в день. Максимальная суточная доза не должна превышать 4 таблетки.</p>\n<p class="small-mb">Продолжительность приема в качестве жаропонижающего средства не должна превышать 3 дней и не более 5 дней &#8212; в качестве обезболивающего.<br />\nНе следует превышать указанные дозы препарата. Детям до 18 лет препарат противопоказан.</p>\n',
      file: 'https://spasmalgon.teva.ru/spas.effect.15.02.2023_0002.pdf',
      sup: 'Скачать листок-вкладыш – информация для пациента Спазмалгон® ЭФФЕКТ ЛП-№(001820)-(РГ-RU)'
    },
    _links: {
      self: [
        {
          href: 'https://spasmalgon.teva.ru/wp-json/wp/v2/instrucrions/65',
        },
      ],
      collection: [
        {
          href: 'https://spasmalgon.teva.ru/wp-json/wp/v2/instrucrions',
        },
      ],
      about: [
        {
          href: 'https://spasmalgon.teva.ru/wp-json/wp/v2/types/instrucrions',
        },
      ],
      'wp:attachment': [
        {
          href: 'https://spasmalgon.teva.ru/wp-json/wp/v2/media?parent=65',
        },
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true,
        },
      ],
    },
  },
];
